import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';

export function BrandMark({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center gap-2.5 px-2 py-2', className)}>
      <img
        src="/logo-mark.png"
        alt={t('app.name')}
        width={36}
        height={36}
        className="rounded-(--radius-control)"
      />
      <div className="min-w-0">
        <p className="text-ink text-base font-bold tracking-tight">{t('app.name')}</p>
        <p className="text-ink-subtle truncate text-xs">{t('app.tagline')}</p>
      </div>
    </div>
  );
}
